import type { components } from '../api/portal-api/portal-api-definition';

/**
 * Represents an error response from the API.
 */
export class NloApiError extends NloError {
	status: number;
	data?: components['schemas']['ProblemDetails'];

	constructor(status: number, errorBody: any) {
		const problemDetails = errorBody as components['schemas']['ProblemDetails'];

		super({ message: problemDetails?.detail ?? getStatusMessage(status), isFatal: status >= 500 });

		this.status = status;
		this.data = problemDetails;
	}
}

function getStatusMessage(status: number) {
	switch (status) {
		case 400:
			return 'Bad request';
		case 401:
			return 'Unauthorized';
		case 403:
			return 'Forbidden';
		case 404:
			return 'Not found';
		case 500:
			return 'Er is iets mis gegaan, probeer het later opnieuw';
		default:
			return 'Unknown error';
	}
}
